import React from 'react';
import { connect } from 'react-redux';

import NavItem from 'react-bootstrap/lib/NavItem';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';

import actionChangeLang from '../actions/i18n';
import { LANGS } from '../i18n/TranslatedText';

const ChangeLang = ({ lang, changeLang }) => (
  <NavDropdown className="text-uppercase" title={lang} id="nav-dropdown">
    {LANGS.filter(l => l !== lang).map(l => (
      <NavItem
        key={`change_lang_${l}`}
        eventKey={`change_lang_${l}`}
        onClick={() => changeLang(l)}
      >
        {' '}
        {l}{' '}
      </NavItem>
    ))}
  </NavDropdown>
);

const mapStateToProps = state => {
  return {
    lang: state.i18n.locale
  };
};

const mapDispatchToProps = {
  changeLang: actionChangeLang
};

export const LangSwitch = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeLang);

class Localizer extends React.Component {
  componentWillMount() {
    const {
      location: { pathname },
      user,
      dispatch
    } = this.props;

    const split = pathname.split('/');
    const localeFromUrl = split.length > 1 ? split[1] : split[0];
    let locale = localeFromUrl;

    if (!LANGS.includes(locale)) {
      if (user) {
        locale = user.language;
      } else {
        if (typeof window !== 'undefined' && window) {
          locale = window.localStorage.getItem('lang');
        }
      }
    }

    if (LANGS.includes(localeFromUrl)) {
      dispatch(actionChangeLang(locale));
    }
  }

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>;
  }
}

const localizerMapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

export default connect(localizerMapStateToProps)(Localizer);
